<div class="background">
  <div class="manage-booking">
    <div *ngIf="isLoading" class="manage-booking__state" role="status">
      <div class="loader" [attr.aria-label]="'manage_booking.loading' | translate"></div>
    </div>

    <div *ngIf="!isLoading && notFound" class="manage-booking__state">
      <h1 class="manage-booking__title">{{ 'manage_booking.not_found_title' | translate }}</h1>
      <p class="manage-booking__hint">{{ 'manage_booking.not_found_text' | translate }}</p>
    </div>

    <ng-container *ngIf="!isLoading && booking">
      <div class="manage-booking__header">
        <div>
          <h1 class="manage-booking__title">{{ 'manage_booking.title' | translate }}</h1>
          <a *ngIf="business" class="manage-booking__business"
            [routerLink]="['/business-services', booking.businessProfileId, 'service']">
            {{ business.businessName }}
          </a>
        </div>
        <appointment-status [status]="booking.status"></appointment-status>
      </div>

      <div *ngIf="justCanceled" class="alert alert-success" role="alert">
        {{ 'manage_booking.canceled_message' | translate }}
      </div>

      <dl class="manage-booking__details">
        <div>
          <dt>{{ 'general.date' | translate }}</dt>
          <dd>{{ booking.startDate | dateLocal }}</dd>
        </div>
        <div>
          <dt>{{ 'manage_booking.time' | translate }}</dt>
          <dd>{{ booking.startDate | date: 'shortTime' }} – {{ booking.endDate | date: 'shortTime' }}</dd>
        </div>
        <div>
          <dt>{{ 'general.selected_service' | translate }}</dt>
          <dd>{{ serviceNames || '-' }}</dd>
        </div>
        <div>
          <dt>{{ 'general.assigned_staff' | translate }}</dt>
          <dd>{{ booking.teamMemberProfileName || '-' }}</dd>
        </div>
        <div *ngIf="business?.address?.city" class="manage-booking__details-wide">
          <dt>{{ 'manage_booking.address' | translate }}</dt>
          <dd>
            {{ business.address.street }} {{ business.address.apartment }}<br>
            {{ business.address.zipCode }} {{ business.address.city }}
          </dd>
        </div>
      </dl>

      <section *ngIf="canCancel" class="manage-booking__cancel">
        <h2 class="manage-booking__subtitle">{{ 'manage_booking.cancel_title' | translate }}</h2>
        <div class="form-outline">
          <label for="manage-booking-reason">{{ 'manage_booking.cancel_reason' | translate }}</label>
          <textarea id="manage-booking-reason" class="form-control" rows="3" maxlength="1000"
            [(ngModel)]="cancellationReason"></textarea>
        </div>
        <div *ngFor="let error of cancelErrors" class="error-text">{{ error | translate }}</div>
        <div class="manage-booking__actions">
          <button type="button" class="btn btn-danger" [disabled]="isCanceling" (click)="cancel()">
            <span *ngIf="isCanceling" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ 'manage_booking.cancel_button' | translate }}
          </button>
        </div>
      </section>

      <p *ngIf="!canCancel && !justCanceled" class="manage-booking__hint">
        {{ 'manage_booking.cannot_cancel' | translate }}
      </p>
    </ng-container>
  </div>
</div>
